/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsRetailerLoginViewProps } from './hosports-retailer-login';

export default (props: IHosportsRetailerLoginViewProps) => {
    return (
        <div>{'Retailer Login'}</div>
    );
};
